import { useCallback, useState } from "react";

export const useUnsavedChangesModal = (isDirty: boolean) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
  const [intendedRoute, setIntendedRoute] = useState<string | null>(null);

  const confirmExit = useCallback(
    (onProceed: () => void) => {
      if (isDirty) {
        setPendingAction(() => onProceed);
        setIsModalOpen(true);
      } else {
        onProceed();
      }
    },
    [isDirty],
  );

  const handleDiscard = useCallback(() => {
    pendingAction?.();
    setIsModalOpen(false);
    setPendingAction(null);
    setIntendedRoute(null);
  }, [pendingAction]);

  const handleContinueEditing = useCallback(() => {
    setIsModalOpen(false);
    setPendingAction(null);
    setIntendedRoute(null);
  }, []);

  return {
    isModalOpen,
    confirmExit,
    handleDiscard,
    handleContinueEditing,
    intendedRoute,
    setIntendedRoute,
  };
};
